import type { OptionTs } from "@ps-bridge/interop";
import {
  optionChain,
  optionFold,
  optionMap,
  optionNone,
  optionSome,
} from "@src/purescript/interop";

export const some = optionSome;
export const none = <A>(): OptionTs<A> => optionNone() as OptionTs<A>;
export const map = optionMap;
export const chain = optionChain;

export const fold = <A, B>(
  option: OptionTs<A>,
  onNone: () => B,
  onSome: (value: A) => B,
): B => optionFold(onNone)(onSome)(option);

// Prefer uncurried `fold` in TS callsites to avoid arity confusion; use `foldC` only when needed.
export const foldC =
  <A, B>(onNone: () => B) =>
  (onSome: (value: A) => B) =>
  (option: OptionTs<A>): B =>
    optionFold(onNone)(onSome)(option);

export const foldFn =
  <A, B>(onNone: () => B, onSome: (value: A) => B) =>
  (option: OptionTs<A>): B =>
    fold(option, onNone, onSome);

export const renderOptionText = <A>(
  option: OptionTs<A>,
  fallback: string,
  render: (value: A) => string,
): string => fold(option, () => fallback, render);
